<template>
  <div>
    <div class="cart-wrapper" v-if="currentStep <= 4">
      <div class="cart-container">
        <div class="cart-main">
          <cart-checkout v-if="currentStep >= 1 && currentStep <= 3" />
          <cart-payment v-if="currentStep === 4" />
          <cart-items />
        </div>
      </div>
    </div>
    <div class="cart-wrapper" v-else>
      <div class="cart-container">
        <div class="cart-main">
          <div></div>
          <cart-confirmation />
        </div>
      </div>
    </div>
    <cart-confirm-free v-if="modalIsOpen" />
  </div>
</template>
<style lang="scss">
.viewer-element {
  .cart-loader {
    position: relative;
    height: rem(100);
    @include loader($black, .7);
  }
  .cart-main {
    @include tablet {
      display: flex;
      justify-content: space-between;
    }
  }
  .cart-error {
    @include form-error;
    @include visible;
    display: block;
  }
  .cart-wrapper {
    line-height: 2;
  }
  .cart-button {
    @include cta {
      width: 100%;
    }
  }
  .cart-title {
    @include upper;
  }
}
</style>
<style scoped lang="scss">

</style>
<script>
import { gsap, Power2 } from 'gsap/all';
import AppControlService from '@/services/AppControl';
import UsersService from '@/services/Users';
import OrdersService from '@/services/Orders';
import ModalService from '@/services/Modal';

import CartItems from '@/components/CartItems';
import CartCheckout from '@/components/CartCheckout';
import CartPayment from '@/components/CartPayment';
import CartConfirmation from '@/components/CartConfirmation';
import CartConfirmFree from '@/components/CartConfirmFree';

export default {
  name: 'App',
  components: {
    CartItems,
    CartCheckout,
    CartPayment,
    CartConfirmation,
    CartConfirmFree
  },
  data: () => {
    return {
      modalIsOpen: ModalService.isOpen,
      currentStep: AppControlService.currentStep
    }
  },
  created () {
    this._toggleModalOpen = this._toggleModalOpen.bind(this);
    ModalService.on('toggle', this._toggleModalOpen);
    UsersService.me();
    AppControlService.on('step', (step) => {
      this.currentStep = step;
      gsap.to(window, {
        duration: .6,
        scrollTo: {
          y: 0
        },
        ease: Power2.easeOut
      });
    });
    UsersService.getCountries();
    document.body.addEventListener('logged', (res) => {
      if(res.detail && AppControlService.currentStep === 0 && !AppControlService.isAuthByStep) {
        window.location.reload();
      }
    });
  },
  beforeDestroy() {
    ModalService.off('toggle', this._toggleModalOpen);
  },
  mounted () {
    OrdersService.get();
  },
  methods: {
    _toggleModalOpen(pEvt) {
      this.modalIsOpen = pEvt;
    }
  }
};
</script>
